import { getSiteUrl } from '../config/seoConfig';
import { buildBrowseSearchParams } from './slugify';

const BROWSE_PATHS = new Set(['/browse', '/categories', '/personas']);

export function normalizePath(pathname = '/') {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '');
}

export function buildCanonicalUrl(pathname, searchParams = {}) {
  const baseUrl = getSiteUrl();
  let path = normalizePath(pathname);

  if (BROWSE_PATHS.has(path)) {
    path = '/browse';
  }

  const params = buildBrowseSearchParams({
    category: searchParams.category || '',
    subcategory: searchParams.subcategory || '',
    persona: searchParams.persona || '',
    search: searchParams.search || '',
  });

  const query = params.toString();
  return `${baseUrl}${path}${query ? `?${query}` : ''}`;
}

export function buildBrowseCanonicalUrl(location, { category = '', subcategory = '', persona = '', search = '' } = {}) {
  return buildCanonicalUrl(location.pathname, { category, subcategory, persona, search });
}
